import {
  bool, number, oneOfType, shape, string,
} from 'prop-types';
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';

import { LAYOUT, SHAPE } from '../../../../common';
import { ImageContent, Uri } from '../../../../components';
import { Consumer } from '../../../../context';
import { LAYOUT as REACTOR } from '../../../../reactor/common';
import {
  Button, Markdown, Motion, Text,
} from '../../../../reactor/components';
import styles from './Content.style';
import { imageSize } from './modules';

class Content extends Component {
  state = { width: REACTOR.VIEWPORT.W };

  _onLayout = ({ nativeEvent: { layout: { width } } }) => this.setState({ width });

  render() {
    const {
      _onLayout,
      props: {
        image, motion, rights, title, text, viewed, visibility, link, ...inherit
      },
      state: { width },
    } = this;

    const hasImage = image && image.source;
    const pageStyle = inherit.style ? inherit.style.split(' ') : [];
    const box = pageStyle.includes('box');
    const centered = pageStyle.includes('centered');
    const { VIEWPORT: { H, PORTRAIT } } = REACTOR;

    return (
      <View
        onLayout={_onLayout}
        style={StyleSheet.flatten([
          styles.container,
          LAYOUT.STYLE.pageContent,
          !PORTRAIT && centered && styles.centered,
          !PORTRAIT && pageStyle.includes('right') && styles.reverse])}
      >
        <Motion
          disabled={!motion}
          style={[
            LAYOUT.STYLE.pageContentText,
            !PORTRAIT && !hasImage && styles.textStandalone,
            box && styles.box,
            box && LAYOUT.STYLE.box,
          ]}
          timeline={[
            (!hasImage && !box && !centered)
              ? { property: 'translateY', value: viewed || visibility > 0.1 ? 0 : H }
              : { property: 'opacity', value: viewed || visibility > 0.1 ? 1 : 0 },
          ]}
        >
          { title && (
            <Text
              headline
              level={PORTRAIT ? 6 : 4}
              color={box ? undefined : inherit.color}
              style={[styles.title, !hasImage && styles.textCenter]}
            >
              {title}
            </Text>)}
          { text && (
            <Markdown color={box ? undefined : inherit.color}>
              {text}
            </Markdown>)}
          { link && (
            <Uri eventProps={{ target: link.uri }} target="_blank" to={link.uri} style={styles.button}>
              <Consumer>
                { ({ dataSource: { primary } = {} }) => <Button {...link} color={link.color || primary} />}
              </Consumer>
            </Uri>)}
        </Motion>
        { hasImage
          && (
          <Motion
            disabled={!motion}
            style={[PORTRAIT && styles.imageFirst]}
            timeline={[
              { property: 'opacity', value: viewed || visibility > 0.33 ? 1 : 0 },
              { property: 'scale', value: viewed || visibility > 0.33 ? 1 : 0.95 },
            ]}
          >
            { image.uri
              ? (
                <Uri to={image.uri} target="_blank">
                  <ImageContent uri={image.source} style={imageSize(pageStyle, width)} />
                </Uri>
              )
              : <ImageContent uri={image.source} style={imageSize(pageStyle, width)} /> }
            { rights && (
              <Text caption color={inherit.color} style={styles.rights}>
                {rights}
              </Text>)}
          </Motion>
          ) }
      </View>
    );
  }
}

Content.propTypes = {
  image: oneOfType([string, shape(SHAPE.IMAGE)]),
  link: shape(SHAPE.LINK),
  motion: bool,
  rights: string,
  title: string,
  text: string.isRequired,
  viewed: bool,
  visibility: number.isRequired,
};

Content.defaultProps = {
  image: undefined,
  link: undefined,
  motion: true,
  rights: undefined,
  title: undefined,
  viewed: false,
};

export default Content;
